/**
 * Parse user-facing dates to ISO YYYY-MM-DD for API / DB.
 * Accepts: dd/mm/yyyy (strict 2-digit day and month) and yyyy-mm-dd (legacy / CSV).
 */

function pad2(n) {
  return String(n).padStart(2, '0');
}

/**
 * @param {string|null|undefined} s
 * @returns {string|null} YYYY-MM-DD or null if invalid / empty
 */
export function formatIsoToDdMmYyyy(iso) {
  if (!iso || !/^\d{4}-\d{2}-\d{2}$/.test(String(iso))) return String(iso ?? '');
  const [y, m, d] = String(iso).split('-');
  return `${d}/${m}/${y}`;
}

export function parseToIso(s) {
  const raw = String(s ?? '').trim();
  if (!raw) return null;

  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [y, mo, d] = raw.split('-').map((x) => parseInt(x, 10));
    const dt = new Date(y, mo - 1, d);
    if (dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) return null;
    return raw;
  }

  const m = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!m) return null;
  const d = parseInt(m[1], 10);
  const mo = parseInt(m[2], 10);
  const y = parseInt(m[3], 10);
  if (mo < 1 || mo > 12 || d < 1 || d > 31) return null;
  const dt = new Date(y, mo - 1, d);
  if (dt.getFullYear() !== y || dt.getMonth() !== mo - 1 || dt.getDate() !== d) return null;
  return `${y}-${pad2(mo)}-${pad2(d)}`;
}
